import { useState, useEffect } from "react";
import {
  Dialog,
  DialogTitle,
  DialogContent,
  DialogActions,
  TextField,
  Button
} from "@mui/material";

const NO_SPECIAL_CHARS_REGEX = /^[a-zA-Z0-9\s]+$/;

export default function AddItemModal({
  open,
  onClose,
  onSave,
  title = "Add Item",
  fields = [],
  useObjectFormat = false 
}) {
  const [formData, setFormData] = useState({});
  const [errors, setErrors] = useState({});

  useEffect(() => {
    if (!open) {
      setFormData({});
      setErrors({});
    }
  }, [open]);

  const handleChange = (name, value) => {
    setFormData((prev) => ({ ...prev, [name]: value }));

    // if (value && !NO_SPECIAL_CHARS_REGEX.test(value)) {
    //   setErrors((prev) => ({
    //     ...prev,
    //     [name]: "Special characters are not allowed"
    //   }));
    // } else {
    //   setErrors((prev) => {
    //     const updated = { ...prev };
    //     delete updated[name];
    //     return updated;
    //   });
    // }
  };

  const isValid =
    fields.every(
      (f) => !f.required || formData[f.name]?.trim()
    ) && Object.keys(errors).length === 0;

  const handleSave = () => {
    if (useObjectFormat) {
      // pass the full formData object
      onSave(formData);
    } else {
      // pass only the raw value of the first field
      const firstFieldName = fields[0]?.name;
      onSave(formData[firstFieldName] || "");
    }
  };

  return (
    <Dialog open={open} onClose={onClose} maxWidth="sm" fullWidth>
      <DialogTitle>{title}</DialogTitle>

      <DialogContent>
        {fields.map((field) => (
          <TextField
            key={field.name}
            label={field.label}
            fullWidth
            required={field.required}
            multiline={field.multiline}
            rows={field.rows || 3}
            margin="dense"
            value={formData[field.name] || ""}
            onChange={(e) => handleChange(field.name, e.target.value)}
            error={!!errors[field.name]}
            helperText={errors[field.name] || " "}
            // FormHelperTextProps={!errors[field.name] && { sx: { mt: 0, mb: 0, lineHeight: 1 } }}
          />
        ))}
      </DialogContent>

      <DialogActions>
        <Button onClick={onClose}>Cancel</Button>
        <Button
          variant="contained"
          disabled={!isValid}
          onClick={handleSave}
        >
          Add
        </Button>
      </DialogActions>
    </Dialog>
  );
}